module.exports = __webpack_public_path__ + "static/media/1POLICY46.13c39e3f.jpg";